import http from '@/api/http'

export default {
  /**
   * サーバから銀行口座データを取得
   */
  fetchBankSetting(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/reward/', {
          page: 'get_bank_account',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 銀行名一覧を取得
   */
  fetchBankNames(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/reward/', {
          page: 'get_bank',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 視点名一覧を取得
   */
  fetchSitenNames(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/reward/', {
          page: 'get_bank',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * サーバに銀行口座データを送信
   */
  submit(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/reward/', {
          page: 'save_bank_account',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
